import React, { useEffect, useRef } from 'react';
import classnames from 'classnames';
import './index.scss';

interface SMSCodeProps {
  codeLength: number;
  submit?: (value: string) => void;
}

const SMSCode = ({ codeLength, submit }: SMSCodeProps) => {
  const inputRef = useRef(null);
  const [value, setValue] = React.useState('');
  const [isOnFocus, setIsOnFocus] = React.useState(false);


  useEffect(() => {
    handleOnFocus();
  }, []);

  useEffect(() => {
    if (value.length === codeLength) {
      submit?.(value);
    }
  }, [value]);

  // 校验value是否有效，仅仅存在数字才有效
  const isInputValueValid = (value: string) => /^\d+$/.test(value);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const val = e.target.value || '';
    if (val && !isInputValueValid(val)) return;
    setValue(val);
  };

  const handlePaste = (e: React.ClipboardEvent<HTMLInputElement>) => {
    // 一定要清除默认行为
    e.preventDefault();
    const val = e.clipboardData.getData('text/plain').slice(0, codeLength);
    if (!isInputValueValid(val)) return;
    setValue(val);
  };

  const handleOnFocus = () => {
    const inputElement = inputRef.current;
    if (!inputElement) return;
    inputElement?.focus();
    setIsOnFocus(true);
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if ([37, 38, 39, 40].includes(e.keyCode)) {
      e.preventDefault();
    }
  };

  return (
    <div className="captcha-input-wrapper">
      <div className="captcha-input__show-item" onClick={handleOnFocus}>
        {Array.from({ length: codeLength }).map((_, index) => (
          <div
            key={index}
            className={classnames(
              'code-input-item',
              isOnFocus
                ? {
                    focus: index === value.length,
                    finish: index + 1 === codeLength && value.length === codeLength,
                  }
                : {},
            )}
          >
            {value.split('')[index] || ''}
          </div>
        ))}
      </div>
      <input
        data-test-id="submit-sms-code-input"
        ref={inputRef}
        className="captcha-input__input"
        maxLength={codeLength}
        type="text"
        inputMode="numeric"
        pattern="\d*"
        autoComplete="one-time-code"
        value={value}
        onChange={handleChange}
        onPaste={handlePaste}
        onBlur={() => setIsOnFocus(false)}
        onKeyDown={handleKeyDown}
      />
    </div>
  );
};

export default React.forwardRef(SMSCode);
